export default __webpack_public_path__ + "static/media/doctor1.aa586208.jpg";